export const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://test.stripe-payment.solidtechapps.com';

export const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'CHF', symbol: 'CHF', name: 'Swiss Franc' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'KRW', symbol: '₩', name: 'South Korean Won' },
];

export const SUBSCRIPTION_INTERVALS = [
  { value: 'week', label: 'Weekly' },
  { value: 'month', label: 'Monthly' },
  { value: 'year', label: 'Yearly' },
];

export const DEFAULT_GAME_SETTINGS = {
  defaultCurrency: 'USD',
  allowedCurrencies: ['USD', 'EUR'],
  subscriptionPlans: {
    weekly: {
      amount: 499,
      currency: 'USD',
      interval: 'week' as const,
      intervalCount: 1,
    },
    monthly: {
      amount: 1499,
      currency: 'USD',
      interval: 'month' as const,
      intervalCount: 1,
    },
    yearly: {
      amount: 9999,
      currency: 'USD',
      interval: 'year' as const,
      intervalCount: 1,
    },
    lifetime: {
      amount: 2999,
      currency: 'USD',
    },
  },
  purchaseBundles: {
    starter_pack: {
      amount: 299,
      currency: 'USD',
    },
    mega_pack: {
      amount: 1999,
      currency: 'USD',
    },
  },
  rateLimits: {
    requests: 100,
    window: 900000,
  },
};

export const DEFAULT_ADJUST_CONFIG = {
  appTokens: {
    default: '',
    oppo: '',
    vivo: '',
  },
  s2sAuthToken: '',
  subscriptionEvents: {
    created: '',
    renewed: '',
    cancelled: '',
  },
  productEvents: {},
};

export const ROUTES = {
  LOGIN: '/login',
  GAMES: '/games',
  CREATE_GAME: '/games/create',
  EDIT_GAME: '/games/:gameId/edit',
  ADJUST_CONFIG: '/adjust-config/:gameId',
  USERS: '/users',
  ANALYTICS: '/analytics',
  PROFILE: '/profile',
};

export const PERMISSIONS = {
  GAMES_READ: 'games.read',
  GAMES_WRITE: 'games.write',
  GAMES_DELETE: 'games.delete',
  PAYMENTS_READ: 'payments.read',
  PAYMENTS_WRITE: 'payments.write',
  SUBSCRIPTIONS_READ: 'subscriptions.read',
  SUBSCRIPTIONS_WRITE: 'subscriptions.write',
  USERS_READ: 'users.read',
  USERS_WRITE: 'users.write',
  USERS_DELETE: 'users.delete',
  ADMIN_FULL: 'admin.full',
};

export const USER_ROLES = {
  SUPER_ADMIN: 'super_admin',
  ADMIN: 'admin',
  DEVELOPER: 'developer',
  VIEWER: 'viewer',
};

export const RATE_LIMIT_WINDOWS = [
  { value: 60000, label: '1 minute' },
  { value: 300000, label: '5 minutes' },
  { value: 900000, label: '15 minutes' },
  { value: 3600000, label: '1 hour' },
  { value: 86400000, label: '24 hours' },
];